import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const WrapperButtonGroup = styled.div`
  display: flex;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid transparent;
  height: 72px;
`

export const Button = styled.button<{ select: boolean }>`
  flex: 1;
  padding: 8px 16px;
  border: none;
  background: ${({ select }) =>
    select ? myPalette.blue.light : myPalette.white.main};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: none;
`
